import useProperties from '@/composables/property/property';

export default function useUserProperty() {
  const { userProperties } = useProperties();

  return { properties: userProperties };
}
